module.exports = __webpack_public_path__ + "images/premium3-c8ad333b8b3e25a4e14cd94c76c83e86.jpg";